/**
 * @desc: -  报表小组件
 * @author: danny
 */
import React from 'react'
import DatePicker from 'antd/lib/date-picker';
import Pagination from 'antd/lib/pagination';


//日期选择组件
export class DateGroup extends React.Component{
	
	constructor(props){
		super(props)
		
		this.state = {
			startTime: null,
			endTime: null,
			endOpen: false,
			defaultStart:this.props.defaultStart,
			defaultEnd:this.props.defaultEnd
		}
		this.disabledStartDate = this.disabledStartDate.bind(this);
		this.disabledEndDate = this.disabledEndDate.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onStartChange = this.onStartChange.bind(this);
		this.onEndChange = this.onEndChange.bind(this);
		this.handleStartOpenChange = this.handleStartOpenChange.bind(this);
		this.handleEndOpenChange = this.handleEndOpenChange.bind(this);
	}
	
	disabledStartDate(startTime) {
		const endTime = this.state.endTime;
		if (!startTime || !endTime) {
			return false;
		}
		return startTime.valueOf() > endTime.valueOf();
	}
	
	disabledEndDate(endTime) {
		const startTime = this.state.startTime;
		if (!endTime || !startTime) {
			return false;
		}
		return endTime.valueOf() <= startTime.valueOf();
	}
	
	onChange(field, value) {
		this.setState({
			[field]: value,
		});
	}
	
	onStartChange(value) {
		this.onChange('startTime', value);
		this.props.onStartChange( value);
	}
	
	onEndChange(value) {
		this.onChange('endTime', value);
		this.props.onEndChange( value);
	}
	
	handleStartOpenChange(open){
		if (!open) {
			this.setState({ endOpen: true });
		}
	}
	
	handleEndOpenChange(open){
		this.setState({ endOpen: open });
	}
	
	
	
	render(){
		const {endOpen} = this.state;
		return <div className="date-group">
			<i className="date-icon"></i>
			<span>日期：</span>
			<div className="picker-warp">
				<DatePicker
					format="YYYY-MM-DD"
					disabledDate={this.disabledStartDate}
					onChange={this.onStartChange}
					onOpenChange={this.handleStartOpenChange}
					placeholder={this.state.defaultStart}
					
				/>
			</div>
			<span>&nbsp;至&nbsp;</span>
			<div className="picker-warp">
				<DatePicker
					format="YYYY-MM-DD"
					disabledDate={this.disabledEndDate}
					onChange={this.onEndChange}
					onOpenChange={this.handleEndOpenChange}
					placeholder={this.state.defaultEnd}
				/>
			</div>
		</div>
	}
}

//下拉选择
export class RangeGroup extends React.Component{
	constructor(props){
		super(props)
		
		this.state = {
			rangeMenuInfo:this.props.rangeMenuInfo,
			currentMenuIndex:0,
			isOpenSelect:false
		}
		
		this.rangeMenuClick = this.rangeMenuClick.bind(this);
		
		
	}
	
	rangeMenuClick(key,optionValue){
		this.setState({
			currentMenuIndex:key,
			isOpenSelect:false
		})
		
		this.props.rangeMenuClick(key,this.state.rangeMenuInfo[this.state.currentMenuIndex],optionValue);
	}
	
	componentWillReceiveProps(nextProps){
		this.setState({
			rangeMenuInfo:nextProps.rangeMenuInfo,
		})
	}
	
	render(){
		const {isOpenSelect} = this.state;
		return <div className="range-warp">
			<span className="range-title">&emsp;{this.props.title}</span>
			<div className="range-box-warp">
				<div  >
					<a onClick={()=>{
						this.setState({
							isOpenSelect:!this.state.isOpenSelect
						})
					}}>
						<span className="value">{this.state.rangeMenuInfo?this.state.rangeMenuInfo[this.state.currentMenuIndex].title:" "}</span>
						<i className="range-icon"></i>
					</a>
					
					<ul className={isOpenSelect?"select-warp":"select-close-warp"}>
						{
							this.state.rangeMenuInfo ?this.state.rangeMenuInfo.map((item,index)=>{
								return <li onClick={()=>{this.rangeMenuClick(index,item.optionValue)}} className="item" key={index}>
									<a >{item.title}</a>
								</li>
							}):<li className="item"> </li>
						}
					</ul>
				</div>
			</div>
		</div>
	}
}

//搜索框
export class SearchGroup extends React.Component{
	
	constructor(props){
		super(props)
		this.state = {
			searchValue:this.props.searchValue,
		}
		
		this.onChange = this.onChange.bind(this);
	}
	
	onChange(event){
		let value = event.target.value;
		this.props.onChange(value);
	}
	
	componentWillReceiveProps(nextProps){
		this.setState({
			searchValue:nextProps.searchValue
		})
	}
	
	render(){
		return <div className="search-warp">
			<span>用户名：</span>
			<div className="search-box-warp">
				<input value={this.state.searchValue} onChange={this.onChange} placeholder="输入用户名查找"/>
				<i className="search-icon"></i>
			</div>
		</div>
	}
}

//页面内选项卡
export class TabBar extends React.Component{
	
	constructor(props){
		super(props)
		this.state = {
			currentIndex : 0
		}
		this.tabClick = this.tabClick.bind(this);
	}
	
	tabClick(item,index) {
		this.setState({
			currentIndex:index
		})
		this.props.tabClick(item,index);
	}
	
	render(){
		return <div className="tabbar-warp">
			<ul>
				{
					this.props.list.map((item,index)=>{
						return <li onClick={()=>{this.tabClick(item,index)}}
						           className={this.state.currentIndex == index? "active":""}
						           key={index}>{item}</li>
					})
				}
			</ul>
		</div>
	}
}

//分页
export class Pagintaion extends React.Component{
	
	constructor(props){
		super(props)
		
		this.state = {
			current:this.props.current,
			page_size:this.props.page_size,
			total_page:this.props.total_page
		}
	}
	
	componentWillReceiveProps(nextPros){
		this.setState({
			total_page:nextPros.total_page,
			page_size:nextPros.page_size,
			info:nextPros.info,
			current:nextPros.current
		})
	}
	
	render(){
		const {info,page_size,total_page,current} = this.state;
		
		return <div className="pagination-warp">
			<Pagination current={current} total={page_size * (total_page ? total_page : 1)} onChange={(page,pagesize)=>{
				this.props.onChange(page,pagesize)
			}} pageSize={page_size} defaultCurrent={1}/>
			<label className="page-info">{info}</label>
		</div>
	}
}

export class Bread extends React.Component{
	constructor(props){
		super(props)
		this.state = {
			bread:this.props.bread
		}
		this.onChange = this.onChange.bind(this);
	}
	
	onChange(item){
		this.props.onChange(item);
	}
	componentWillReceiveProps(nextPros){
		this.setState({
			bread:nextPros.bread
		})
	}
	
	render(){
		const {bread} = this.state;
		if(!bread) return <div></div>;
		return <span className="bread-warp">
			{
				bread.map((item,index)=> {
					return <span className="bread-item" key={index}>
						{index >0 ? '>':''}
							<span className="bread" onClick={()=>this.onChange(item)} >  { item.username}</span>
					</span>
				})
			}
		</span>
	}
	
}